"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _Constants = require("../00_environment/Constants");

var _TitleBlock = _interopRequireDefault(require("./TitleBlock"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormElementGroup = function FormElementGroup(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      _ref$slim = _ref.slim,
      slim = _ref$slim === void 0 ? false : _ref$slim,
      id = _ref.id,
      style = _ref.style,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? null : _ref$backgroundColor;
  var parsedStyle = (0, _Fonts.withDefaultFont)({
    backgroundColor: backgroundColor || 'none',
    marginBottom: 30,
    marginTop: 6
  });

  if (slim) {
    Object.assign(parsedStyle, {
      marginBottom: 0,
      marginTop: 0
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_TitleBlock["default"], {
    id: id,
    title: title,
    subtitle: subtitle,
    slim: slim,
    style: style,
    padding: 10
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: parsedStyle
  }, children));
};

var _default = FormElementGroup;
exports["default"] = _default;